import React from 'react';

import {
  EXPERIMENT_NAME_PROPERTY,
  EXPERIMENT_STARTED_EVENT,
  EXPERIMENT_VARIANT_PROPERTY,
} from 'apps/experiment-reporting/src/experiment-reporting-app/constants';
import {useCurrentProject} from 'common/contexts/react/current-project-context';

export function useExperimentSettings() {
  const experimentSettings = useCurrentProject().get()?.value?.experimentSettings;
  return React.useMemo(() => {
    return {
      eventName: experimentSettings?.eventName || EXPERIMENT_STARTED_EVENT,
      nameProperty: experimentSettings?.nameProperty || {value: EXPERIMENT_NAME_PROPERTY},
      variantProperty: experimentSettings?.variantProperty || {value: EXPERIMENT_VARIANT_PROPERTY},
    };
  }, [experimentSettings]);
}
